'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonIconBoxStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  /** Define button's size */
  size: _propTypes2.default.oneOf(['inline', 'small', 'normal', 'large']),

  /** Swap icon and text position */
  iconPositionRight: _propTypes2.default.bool
};
var defaultProps = {
  size: 'normal',
  iconPositionRight: false
}; // PROP RECEIVERS

var iconStyleProps = function iconStyleProps(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.button;
  var opacityAmount = path.iconOpacity;
  return (0, _styledComponents.css)(['opacity:', ';svg{fill:currentColor;}'], opacityAmount);
};

var iconSizeProps = function iconSizeProps(_ref2) {
  var size = _ref2.size,
      themeFromProvider = _ref2.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.button.size[size].icon;
  return (0, _styledComponents.css)(['', ' ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(path.width), (0, _reactackleCore.getValueString)(path.imgSize || path.width), (0, _reactackleCore.getValueString)(path.height || path.width)), size === 'inline' && '\n      display: inline-flex;\n      align-self: center;\n    ');
};

var ButtonIconBoxStyled = exports.ButtonIconBoxStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ButtonIconStyled__ButtonIconBoxStyled'
})(['order:', ';display:flex;align-items:center;justify-content:center;', ';', ';'], function (props) {
  return props.iconPositionRight ? '2' : '1';
}, iconStyleProps, iconSizeProps);

ButtonIconBoxStyled.propTypes = propTypes;
ButtonIconBoxStyled.defaultProps = defaultProps;
ButtonIconBoxStyled.displayName = 'ButtonIconBoxStyled';